import React from 'react'
import './Background.scss'

export default function Background() {
  return (
    <div className="bg">
      {/* moon */}
      {/* <div className="moon"></div> */}

      {/* santa */}
      {/* <div class="santaWrapper">
        <div class="santa">
          <div class="hat">
            <div></div>
            <div></div>
          </div>
          <div class="face">
            <div class="eyeBrows left"></div>
            <div class="eyeBrows right"></div>
            <div class="eye left"></div>
            <div class="eye right"></div>
            <div class="nose"></div>
            <div class="cheek left"></div>
            <div class="cheek right"></div>
            <div class="beard">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="body">
            <div class="sweater"></div>
            <div class="hand left">
              <div class="inner"></div>
            </div>
            <div class="hand right"></div>
          </div>
        </div>
        <div class="rope"></div>
        <div class="rope back"></div>
        <div class="sled"></div>
        <div class="reindeer">
          <div class="face">
            <div class="ear"></div>
            <div class="horn right"></div>
            <div class="horn left"></div>
          </div>
          <div class="body">
            <div class="foot front">
              <div class="inner">
                <div class="extension"></div>
              </div>
            </div>
            <div class="foot back">
              <div class="inner">
                <div class="extension"></div>
              </div>
            </div>
            <div class="tail"></div>
          </div>
        </div>
        <div class="reindeer second">
          <div class="rope"></div>
          <div class="face">
            <div class="ear"></div>
            <div class="horn right"></div>
            <div class="horn left"></div>
          </div>
          <div class="body">
            <div class="foot front">
              <div class="inner">
                <div class="extension"></div>
              </div>
            </div>
            <div class="foot back">
              <div class="inner">
                <div class="extension"></div>
              </div>
            </div>
            <div class="tail"></div>
          </div>
        </div>
      </div> */}

      {/* snow */}
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
      <div className="snow"></div>
    </div>
  )
}
